import { Injectable} from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class KeyPressValidatorsService {

  constructor() { }

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  //Only Numbers
  keyPressNumbers(event) {
    /*var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    // if ((charCode < 48 || charCode > 57))
    if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43)
    {
      event.preventDefault();
      return false;
    } else {
      return true;
    }*/
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  // // Only AlphaNumeric
  // keyPressAlphaNumeric(event) {
  //   var inp = String.fromCharCode(event.keyCode);
  //   if (/[a-zA-Z0-9]/.test(inp)) {
  //     return true;
  //   } else {
  //     event.preventDefault();
  //     return false;
  //   }
  // }
  // // Only Alpha
  // keyPressAlpha(event) {
  //   var inp = String.fromCharCode(event.keyCode);
  //   if (/[a-zA-Z]/.test(inp)) {
  //     return true;
  //   } else {
  //     event.preventDefault();
  //     return false;
  //   }
  // }


  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
   //  if (/[a-zA-Z0-9]/.test(inp)) {
     if (/[a-zA-Z0-9_ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
   // Only Alpha
   keyPressAlpha(event) {
     var inp = String.fromCharCode(event.keyCode);
     if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
     // if (!/[a-zA-Z_ ]/.test(inp)) {
     //   event.preventDefault();
     //   return false;
     // }
     if (/[a-zA-Z ]/.test(inp)) {
       return true;
     }
      else {
       event.preventDefault();
       return false;
     }
   }

  verifyInputLength(event, inputVal, minLength, maxLength) {
    if ((inputVal.length + 1) > maxLength || (inputVal.minLength + 1) < minLength) {
      event.preventDefault();
      return false;
    }
    else {
      return true;
    }
  }

  keyPressDeciamlValue(event) {
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      return false;
    }
    return true;
  }



  keyPressAlphaNumericWithSpace(event) {
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z0-9_ ]*$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressNumericWithSpace(event) {
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
    var inp = String.fromCharCode(event.keyCode);
    if (/^[xX0-9 ]*$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  KeyPressWithDynamicPattern(event,pattern) {
    debugger
    var substring = 'd{0,';
  if(pattern.includes(substring)==false)
  {
    var reg=new RegExp(pattern);;
    var inp = String.fromCharCode(event.keyCode);
    if (reg.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  else{
    //Support 4 digit before decimal and 2 digit after decimal
    let regex: RegExp = new RegExp(/^(\d{1,4}|(\d{1,4}\.)?\d{0,2})$/);
    let value = event.target.value;
     let current: string = value;
      const position = event.target.selectionStart;
      const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
      if (next && !String(next).match(pattern)) {
       event.preventDefault();
      }
    }
  }

  keyPressDecimalNumbersWithComma(event) {
    
    /*var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    // if ((charCode < 48 || charCode > 57))
    if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43)
    {
      event.preventDefault();
      return false;
    } else {
      return true;
    }*/
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9,.]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  keyPressAlphaNumericWithSC(event) {    //Support Special Charcter
    var inp = String.fromCharCode(event.keyCode);
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
     if (/[a-zA-Z0-9_!"#$%&'()*+,-./:;<=>?@[\]^`{|}~]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericWithSCandSpace(event) {    //Support Special Charcter and Spcae
    var inp = String.fromCharCode(event.keyCode);
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
     {
       event.preventDefault();
       return false;
     }
     if (/[a-zA-Z0-9_ !"#$%&'()*+,-./:;<=>?@[\]^`{|}~]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaWithSC(event) {     //Support Special Charcter
    var inp = String.fromCharCode(event.keyCode);
    if ( event.srcElement.selectionStart === 0 && event.keyCode === 32)
    {
      event.preventDefault();
      return false;
    }
    if (/[a-zA-Z_!"#$%&'()*+,-./:;<=>?@[\]^`{|}~]/.test(inp)) {
      return true;
    }
     else {
      event.preventDefault();
      return false;
    }
  }

  // Only Email
  keyPressEmail(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (event.keyCode === 32)
    {
      event.preventDefault();
      return false;
    }
  }

  keyPressTime(evt) {
    var inp = String.fromCharCode(evt.keyCode);
    console.log(inp)
    if (/[0-9:]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
    // var theEvent = evt || window.event;
    // var key = theEvent.keyCode || theEvent.which;
    // key = String.fromCharCode(key);
    // if (key.length == 0) return;
    // var regex = /^[0-9:\b]+$/;
    // if (!regex.test(key)) {
    //     theEvent.returnValue = false;
    //     if (theEvent.preventDefault) theEvent.preventDefault();
    // }
  }


}

export function CheckNull(controlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    // Regular Expression
    let reg = new RegExp(null);
    console.log("control.value)" ,control.value);
    if (control.value == null) {
      control.setErrors({ checknull: true });
    } else {
      control.setErrors(control.errors)
    }
  }

}




